<template>
<div id="valores">
    <div class="container-fluid">
         <div class="row main-content">
         <div class="col-md-12" data-aos="fade-down">
             <div class="small-title">
                         <hr> <h4 v-html="state.title"></h4>
            </div>
              <div>
                        <h1>{{state.subTitle1}}</h1>
                        <div class="img-valores">
                        <div class="img-div">
                            <img src="./../../assets/icons/icon_honestidad.png">
                            <p>{{state.subTitle2}}</p>
                        </div>
                        <div class="img-div"><img src="./../../assets/icons/icon_confiabilidad.png"><p>{{state.valueImgTxt1}}</p></div>
                        <div class="img-div"><img src="./../../assets/icons/icon_responsabilidad.png"><p>{{state.valueImgTxt2}}</p></div>
                        <div class="img-div"><img src="./../../assets/icons/icon_compromiso.png"><p>{{state.valueImgTxt3}}</p> </div>
                        <div class="img-div"> <img src="./../../assets/icons/icon_innovacion.png"><p>{{state.valueImgTxt4}}</p> </div> 
                        </div>
                        <iframe style="margin-top:20px;" :src="state.valuesVideo" frameborder="0" allowfullscreen></iframe>
            </div>
          </div>   
        </div>
    </div>
</div>
</template>

<script>
export default { 

  methods:{
  },
  components:{  
  },
  computed:{
      state(){
          return this.$store.state.activeList.aboutUsValues
      }
  },
  mounted(){

  }
}
</script>

<style lang="scss" scoped>
@import '~varmix';


#valores{
  background-color:white;
  color:$azul;
}
.main-content{
    margin-top:100px;
}
h2{
    color:white;
     display:inline-block;
}
h4{
    color:$gris;
     display:inline-block;
}
hr{
    display:inline-block;
    vertical-align:middle;
    height: 2px;
    border: 0;
    width:30%;
    border-top: 2px solid $rojo;
    margin: 1em 1em;
    padding: 0; 

}

iframe{
    width:70%;
    height:515px;
}

.img-div{
    display:inline-block;
    color:$gris;
}

.text-container{
    text-align:left;
    margin-top:5%;
}

.small-title{
    text-align:right;
    vertical-align:middle;
}

.img-contnt{
    text-align:right;
}

.img-valores img{
    width:100px;
   margin:40px;
}

.container-fluid, .col-md-9, .col-md-6, .col-md-3, .col-md-10, .col-md-12{
  padding-left:0px !important;
  padding-right:0px !important;
}

.row, .col-md-9, .col-md-3, .col-md-10, .col-md-12{
  margin-left:0px!important;
  margin-right:0px!important;
} 

@media screen and (max-width:1040px) {
.small-title{
    text-align:left;
    vertical-align:middle;
    padding:40px 10px;
}

iframe{
    width:100%;
}

}
</style>



// WEBPACK FOOTER //
// ValoresPage.vue?49a93474